import { render } from "./documents.vue?vue&type=template&id=0d33ee63"
import script from "./documents.vue?vue&type=script&lang=js"
export * from "./documents.vue?vue&type=script&lang=js"

import "./documents.vue?vue&type=style&index=0&id=0d33ee63&lang=css"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__